import React from 'react';
import { Link } from 'react-router-dom';
import { SiteLayout, FLAME, FLAME_2, INK, BODY, MUTED, BORDER, MONO, btnFlame } from './SiteLayout';
import AdsTxtCheckerEmbed from './AdsTxtCheckerEmbed';

const TOOLS = [
  { n: '01', name: 'Ads.txt / App-ads.txt Checker', free: true, desc: 'Validate and check ads.txt — catch unauthorized resellers or incorrect entries before they cost you revenue. Free, forever.' },
  { n: '02', name: 'App Category Segmenter', desc: 'Segment your in-app inventory based on app categories within seconds.' },
  { n: '03', name: 'Sellers.json Explorer', desc: 'Search and audit any seller declaration instantly — no manual digging.' },
  { n: '04', name: 'Supply Chain (schain) Map', desc: 'Trace the full path from publisher to you in seconds — see every hop laid out and validated before your DSP flags it.' },
  { n: '05', name: 'Crawler', desc: 'The fastest way to crawl inventory for the lines you input. Works for domains, mobile apps and CTV apps. Crawl up to 1000 bundles in under 3 minutes.' },
  { n: '06', name: 'Inventory Tracker', desc: 'One place to keep track of all your approved inventory. Get alerted the moment a partner drops your lines or an app leaves the store.' },
  { n: '07', name: 'Bid Request Analyzer', desc: "Inspect any bid request A→Z — what's missing, what's malformed, and how to improve it." },
  { n: '08', name: 'Inventory Lookup', desc: 'Pull your inventory info in seconds instead of hours — or days — of manual work, with all the details you need in the results.' },
  { n: '09', name: 'Revenue Discrepancy Monitor', desc: "Your numbers vs every partner's, in one view, with a single one-time setup." },
];

const cardBase = {
  background: 'rgba(255,255,255,.88)', border: `1px solid ${BORDER}`,
  borderRadius: '14px', padding: '24px', position: 'relative',
};

export default function ProductsPage() {
  return (
    <SiteLayout>

      {/* ── HERO ── */}
      <section style={{ maxWidth: '1180px', margin: '0 auto', padding: '88px 32px 56px', textAlign: 'center' }}>
        <p style={{ fontFamily: MONO, fontSize: '20px', letterSpacing: '1.6px', color: FLAME, textTransform: 'uppercase', margin: 0 }}>
          The AdTech Hub suite
        </p>
        <h1 className="ia-hero-h1" style={{
          fontSize: '56px', lineHeight: 1.04, fontWeight: 600, letterSpacing: '-1.6px',
          margin: '22px auto 0', maxWidth: '840px', textWrap: 'balance',
        }}>
          Eleven+ tools all in <span style={{ fontStyle: 'italic', color: FLAME }}>one hub</span>.
        </h1>
        <p style={{ fontSize: '20px', color: BODY, maxWidth: '600px', margin: '22px auto 0', lineHeight: 1.55 }}>
          Every check your AdOps team runs by hand — validation, monitoring, fetching, analysis — now in one login,
          on one subscription. Most finish in seconds.
        </p>
        <div style={{
          display: 'flex', gap: '24px', justifyContent: 'center', marginTop: '26px',
          fontFamily: MONO, alignItems: 'center', flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: '18px', fontWeight: 800 }}>11+ tools</span>
          <span style={{ color: '#d8d4cb' }}>·</span>
          <span style={{ fontSize: '18px', fontWeight: 800 }}>One subscription</span>
          <span style={{ color: '#d8d4cb' }}>·</span>
          <span style={{ fontSize: '18px', fontWeight: 800 }}>Priority support</span>
        </div>
      </section>

      {/* ── FREE TOOL: live ads.txt checker ── */}
      <section style={{ maxWidth: '1040px', margin: '0 auto', padding: '0 32px 40px' }}>
        <AdsTxtCheckerEmbed />
      </section>

      {/* ── TOOLS GRID ── */}
      <section style={{ maxWidth: '1180px', margin: '0 auto', padding: '0 32px 30px' }}>
        <h2 style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' }}>
          All tools in the suite
        </h2>

        <div className="ia-grid-3" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '18px' }}>
          {TOOLS.map(({ n, name, desc, free }) => (
            <div key={n} style={cardBase}>
              {free && (
                <span style={{
                  position: 'absolute', top: '18px', right: '18px', fontFamily: MONO,
                  fontSize: '9px', letterSpacing: '1px', color: '#16a34a',
                  border: '1px solid #bfe3c8', background: '#eefaf0',
                  padding: '3px 8px', borderRadius: '20px',
                }}>FREE</span>
              )}
              <div style={{ fontFamily: MONO, fontSize: '11px', color: FLAME }}>{n}</div>
              <h3 style={{ fontSize: '20px', fontWeight: 600, marginTop: '12px', marginBottom: 0, paddingRight: free ? '54px' : 0 }}>{name}</h3>
              <p style={{ fontSize: '16px', color: BODY, lineHeight: 1.55, marginTop: '8px' }}>{desc}</p>
            </div>
          ))}

          {/* Fetch Engine — dark card */}
          <div style={{ ...cardBase, background: INK, color: '#f6f5f2', border: `1px solid ${INK}` }}>
            <div style={{ fontFamily: MONO, fontSize: '11px', color: FLAME_2 }}>10</div>
            <h3 style={{ fontSize: '20px', fontWeight: 600, marginTop: '12px', marginBottom: 0 }}>Fetch Engine</h3>
            <p style={{ fontSize: '16px', color: '#b8b2a7', lineHeight: 1.55, marginTop: '8px' }}>
              Pull your ad-server and partner data from one place — no logging into a dozen dashboards.
            </p>
          </div>

          {/* More coming */}
          <div style={{
            background: 'rgba(255,255,255,.55)', border: '1px dashed #c8c2b6',
            borderRadius: '14px', padding: '24px',
            display: 'flex', flexDirection: 'column', justifyContent: 'center',
          }}>
            <h3 style={{ fontSize: '20px', fontWeight: 600, margin: 0 }}>+ more in the suite</h3>
            <p style={{ fontSize: '16px', color: BODY, lineHeight: 1.55, marginTop: '8px' }}>
              New tools ship regularly — each one shaving another chunk off your team's manual workload.
            </p>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ marginTop: '72px', padding: '80px 32px', textAlign: 'center', background: INK, color: '#f6f5f2' }}>
        <h2 style={{ fontSize: '36px', fontWeight: 600, letterSpacing: '-1px', margin: 0 }}>
          One login. One subscription. The whole suite.
        </h2>
        <p style={{ fontSize: '16px', color: '#a8a297', marginTop: '14px' }}>
          Start with the free tool — add the rest whenever your team is ready.
        </p>
        <Link to="/contact" className="ia-btn" style={{ ...btnFlame, marginTop: '26px' }}>See pricing</Link>
      </section>

    </SiteLayout>
  );
}
